export const ROWS_PER_PAGE = 100
export const AUTOSAVE_TIME_DEFAULT = 30

export const STYLE_ANN_STROKE_WIDTH_DEFAULT = 2
export const STYLE_ANN_STROKE_OPACITY_DEFAULT = 65 / 100
export const STYLE_ANN_FILL_OPACITY_DEFAULT = 25 / 100

export const STYLE_GUIDES_ENABLED_DEFAULT = true
export const STYLE_GUIDES_WIDTH_DEFAULT = 2
